export class RedisInterfacePreload {
  clients: Array<any>
}
